import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { maloneConfig } from "./data";

export default function MalonePage() {
  return <CityPageTemplate config={maloneConfig} />;
}